import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchPackages = () => api.get("/packages").then((r) => r.data);
export const fetchPackage = (id) => api.get(`/packages/${id}`).then((r) => r.data);
export const fetchServices = () => api.get("/services").then((r) => r.data);
export const fetchShahiSnanDates = () => api.get("/shahi-snan-dates").then((r) => r.data);
export const fetchEventInfo = () => api.get("/event-info").then((r) => r.data);
export const submitInquiry = (payload) => api.post("/inquiries", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
